import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

import { computed } from 'vue'
import { useNamespace } from '@unpack-ui/hooks'
import { cardProps } from './card'


export default /*#__PURE__*/_defineComponent({
  ...{ name: 'u-card' },
  __name: 'card',
  props: cardProps,
  setup(__props) {

const props = __props;




const ns = useNamespace('card')

const shadow = computed(() => {
  const shadows = ['always', 'hover', 'never']
  return shadows.includes(props.shadow)
    ? `${ns.is(`${props.shadow}-shadow`)}`
    : `${ns.is('never-shadow')}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_unref(ns).b(), shadow.value])
  }, [
    (_ctx.$slots.header || _ctx.header)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_unref(ns).e('header')),
          style: _normalizeStyle(_ctx.headerStyle)
        }, [
          _renderSlot(_ctx.$slots, "header", {}, () => [
            _createTextVNode(_toDisplayString(_ctx.header), 1 /* TEXT */)
          ])
        ], 6 /* CLASS, STYLE */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass(_unref(ns).e('body')),
      style: _normalizeStyle(_ctx.bodyStyle)
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 6 /* CLASS, STYLE */),
    (_ctx.$slots.footer)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(_unref(ns).e('footer')),
          style: _normalizeStyle(_ctx.footerStyle)
        }, [
          _renderSlot(_ctx.$slots, "footer")
        ], 6 /* CLASS, STYLE */))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}
}

})